"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var delay_1 = __importDefault(require("../delay"));
var types_1 = require("../data/types");
var rand_1 = require("../tools/rand");
var names_1 = require("../data/names");
var resources_1 = __importDefault(require("../resources"));
var config_1 = __importDefault(require("../../config"));
var Item = /** @class */ (function () {
    function Item(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, category = _b.category, name = _b.name, craefterId = _b.craefterId, slot = _b.slot, _c = _b.level, level = _c === void 0 ? 1 : _c, type = _b.type, rarity = _b.rarity, material = _b.material, resources = _b.resources, _d = _b.delay, delay = _d === void 0 ? config_1.default.initialItemDelay : _d;
        this.equipped = false;
        this.isMultiSlot = false;
        this.id = rand_1.getRandomId();
        this.category = category;
        this.craefterId = craefterId;
        this.slot = slot;
        this.level = level;
        this.type = type;
        this.rarity = rarity;
        this.material = material;
        this.resources = resources;
        this.name = name;
        this.rarity = rarity || Item.evaluateRarity();
        this.delay = new delay_1.default({
            delayInSeconds: delay,
            onDelayExpired: function () {
                _this.meterialize();
            }
        });
    }
    Item.prototype.getName = function () {
        return this.name || this.evaluateItemName();
    };
    Item.prototype.evaluateItemName = function () {
        return names_1.RarityNames[this.rarity] + " " + names_1.SlotNames[this.slot] + " " + names_1.ItemNames[this.type];
    };
    Item.evaluateRarity = function () {
        var chance = Math.random() * 100;
        if (chance < config_1.default.rarityChancePercentCommon) {
            return types_1.Rarities.Common;
        }
        else if (chance < config_1.default.rarityChancePercentRare) {
            return types_1.Rarities.Rare;
        }
        else if (chance < config_1.default.rarityChancePercentEpic) {
            return types_1.Rarities.Epic;
        }
        // 98-99
        else {
            return types_1.Rarities.Legendary;
        }
    };
    Item.prototype.tick = function () {
        // todo: tick, tock
    };
    Item.prototype.meterialize = function () {
        if (this.onDoneCreating) {
            this.onDoneCreating(this.craefterId, 
            // todo evaluate exp properly
            this.resources.sum() * 2);
        }
    };
    Item.prototype.disentchant = function () {
        var _a, _b;
        // this item did not have any resources
        if (!this.resources) {
            // return a dummy set
            return new resources_1.default({
                resources: (_a = {},
                    _a[types_1.ResourceTypes.Wood] = 1,
                    _a)
            });
        }
        return new resources_1.default({
            resources: (_b = {},
                _b[types_1.ResourceTypes.Wood] = rand_1.getRandomInt(Math.floor(this.resources[types_1.ResourceTypes.Wood] / 100 * config_1.default.disentchantRecyclingPercentFrom), Math.floor(this.resources[types_1.ResourceTypes.Wood] / 100 * config_1.default.disentchantRecyclingPercentTo)),
                _b[types_1.ResourceTypes.Metal] = rand_1.getRandomInt(Math.floor(this.resources[types_1.ResourceTypes.Metal] / 100 * config_1.default.disentchantRecyclingPercentFrom), Math.floor(this.resources[types_1.ResourceTypes.Metal] / 100 * config_1.default.disentchantRecyclingPercentTo)),
                _b[types_1.ResourceTypes.Diamond] = rand_1.getRandomInt(Math.floor(this.resources[types_1.ResourceTypes.Diamond] / 100 * config_1.default.disentchantRecyclingPercentFrom), Math.floor(this.resources[types_1.ResourceTypes.Diamond] / 100 * config_1.default.disentchantRecyclingPercentTo)),
                _b[types_1.ResourceTypes.Cloth] = rand_1.getRandomInt(Math.floor(this.resources[types_1.ResourceTypes.Cloth] / 100 * config_1.default.disentchantRecyclingPercentFrom), Math.floor(this.resources[types_1.ResourceTypes.Cloth] / 100 * config_1.default.disentchantRecyclingPercentTo)),
                _b)
        });
    };
    Item.hydrate = function (item, obj) {
        item.delay = delay_1.default.hydrate(obj.delay);
    };
    return Item;
}());
exports.default = Item;
